const SMALL_MAX = 80;
const MEDIUM_MAX = 250;
const LARGE_MAX = 500;
const XLARGE_MAX = 800;

export const resolveFieldDisplaySize = (maxLength = 0) => {
  const n = Number(maxLength) || 0;

  if (n <= SMALL_MAX) {
    return {
      tier: 'small',
      minRows: 2,
      maxRows: 4,
      asTextarea: n > 40
    };
  }

  if (n <= MEDIUM_MAX) {
    return {
      tier: 'medium',
      minRows: 3,
      maxRows: 8,
      asTextarea: true
    };
  }

  if (n <= LARGE_MAX) {
    return {
      tier: 'large',
      minRows: 4,
      maxRows: 12,
      asTextarea: true
    };
  }

  if (n <= XLARGE_MAX) {
    return {
      tier: 'xlarge',
      minRows: 6,
      maxRows: 16,
      asTextarea: true
    };
  }

  return {
    tier: 'huge',
    minRows: 8,
    maxRows: 20,
    asTextarea: true
  };
};

export const fieldAutosizeStyle = {
  width: '100%',
  padding: '10px',
  lineHeight: '1.45',
  overflow: 'auto'
};
